import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { assignableShiftsResolver } from '../../shared/resolvers/assignable-shifts.resolver';

export const driverPlanningRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.DriverPlanning.List.Title'),
    loadComponent: () =>
      import('./driver-planning-list/driver-planning-list.component').then(
        (m) => m.DriverPlanningListComponent,
      ),
    resolve: { assignableShifts: assignableShiftsResolver },
  },
];
